'use client'
import { ModalBody as ChakraModalBody } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { ModalBodyProps } from './ModalBody.types'

export default forwardRef(function ModalBody(
  props: ModalBodyProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraModalBody {...props} ref={ref} translate="no" />
})
